import React from 'react';
import { FiGithub, FiLinkedin, FiMail } from 'react-icons/fi';

const Footer = () => {
    const handleNavClick = (e, targetId) => {
        e.preventDefault();
        const el = document.getElementById(targetId);
        if (!el) return;
        // Use window.scrollTo so Lenis can intercept and animate it smoothly,
        // rather than calling el.scrollIntoView() which bypasses Lenis.
        window.scrollTo({
            top: el.getBoundingClientRect().top + window.scrollY - 80,
            behavior: 'smooth',
        });
    };

    return (
        <footer className="footer">
            <div className="footer-content">
                <div className="footer-top">
                    <div className="footer-brand">
                        <span className="footer-logo">Morpheus Vibaen J</span>
                        <p className="footer-tagline">Software Developer</p>
                    </div>
                    <nav className="footer-nav" aria-label="Footer navigation">
                        <a href="#projects" onClick={(e) => handleNavClick(e, 'projects')}>Projects</a>
                        <a href="#skills" onClick={(e) => handleNavClick(e, 'skills')}>Skills</a>
                        <a href="#experience" onClick={(e) => handleNavClick(e, 'experience')}>Experience</a>
                        <a href="#about" onClick={(e) => handleNavClick(e, 'about')}>About</a>
                        <a href="#contact" onClick={(e) => handleNavClick(e, 'contact')}>Contact</a>
                    </nav>
                    <div className="footer-socials">
                        <a href="https://github.com/Vibaen" target="_blank" rel="noopener noreferrer" aria-label="GitHub">
                            <FiGithub />
                        </a>
                        <a href="https://linkedin.com/in/morpheus-vibaen-j" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                            <FiLinkedin />
                        </a>
                        <a href="#contact" onClick={(e) => handleNavClick(e, 'contact')} aria-label="Contact">
                            <FiMail />
                        </a>
                    </div>
                </div>
                <div className="footer-bottom">
                    <p>&copy; 2026 Morpheus Vibaen J. All rights reserved.</p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
